import RestModel from "discourse/models/rest";

export default class AttributesModel extends RestModel {
  static attributes() {
    throw new Error("attributes() must be implemented.");
  }

  static attributeNames() {
    return this.attributes().map((a) => a.name);
  }

  static attributesDefaults() {
    return this.attributes().reduce((obj, v) => {
      obj[v.name] = v.defaultValue;
      return obj;
    }, {});
  }

  static attributeByName(name) {
    return this.attributes().find((a) => a.name === name);
  }
}
